import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/qrcode.png'
import _imports_1 from '@/assets/mobile/wechat.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "page_content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { id: "wetch_des" }, "点击一下二维码关注我们归农读书会"),
  /*#__PURE__*/_createElementVNode("img", {
    id: "wechat",
    src: _imports_1
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageFooter = _resolveComponent("PageFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_PageFooter)
  ], 64))
}